import { useContext } from 'react';
import { BagScanContext } from './context';

export const useBagScanContext = () => {
	const context = useContext(BagScanContext);
	if (!context) {
		throw new Error('useBagScanContext must be used within a BagScanContextProvider');
	}
	return context;
};
